import http from "@/http";
// ### 用户组列表
// https://zs.xzu.ink/api/group/list
export const getUserGroup = {
  p: "/api/group/list",
  r: data => {
    return http({
      url: "/api/group/list",
      method: "post",
      data
    });
  }
};
//### 用户组详细信息
// https://zs.xzu.ink/api/group/details/1
export const getUserGroupInfo = {
  p: "/api/group/details",
  r: data => {
    return http({
      url: "/api/group/details/" + data.id,
      method: "get"
      // data
    });
  }
};
// ### 添加用户组
// https://zs.xzu.ink/api/group/add
export const addUserGroup = {
  p: "/api/group/add",
  r: data => {
    return http({
      url: "/api/group/add",
      method: "post",
      data
    });
  }
};
//   ### 修改
//   https://zs.xzu.ink/api/group/edit
export const editUserGroup = {
  p: "/api/group/edit",
  r: data => {
    return http({
      url: "/api/group/edit",
      method: "post",
      data
    });
  }
};
//   ### 删除
// https://zs.xzu.ink/api/group/delete
export const deleteUserGroup = {
  p: "/api/group/delete",
  r: data => {
    return http({
      url: "/api/group/delete",
      method: "post",
      data
    });
  }
};
//   ### 获取设置列表
//https://zs.xzu.ink/api/group/all
export const deleteUserGroupAll = {
  p: "/api/group/all",
  r: data => {
    return http({
      url: "/api/group/all",
      method: "get"
      // data
    });
  }
};
